import { useSession } from '../Components/Session';
import { useUnreadThreads } from './Messages';
import { Roles } from './Users';

const useHomeBadge = () => {
    const {notificationBadge, isRoleSufficient} = useSession();
    const {unread} = useUnreadThreads(!isRoleSufficient(Roles.Manager));

    const inboxBadge = unread?.length > 0;

    return inboxBadge || notificationBadge;
}

export default useHomeBadge;
